<template>
  <highcharts class="fit-highchart" :options="options" style="width: 100%" />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { stackedColumnOptions } from '@/constants/chart-options';
import { getDateToString } from '@/utils/date';

export default {
  name: 'WSummaryStackedColumnChart',
  props: {
    series: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      options: cloneDeep(stackedColumnOptions),
    };
  },
  watch: {
    series(value) {
      this.options.chart.height = '140px';
      this.options.series = value;
      this.options.tooltip = {
        xDateFormat: '%Y-%m-%d %H:%M:%S',
        split: false,
        shared: true,
        // valueDecimals: 2,
        formatter() {
          let tooltip = getDateToString(this.x, 'YYYY-MM-DD HH:mm:ss');
          this.points.forEach((point) => {
            tooltip += `<br/>${point.series.name}: ${point.y}<br/>`;
          });
          return tooltip;
        },
      };
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/SummaryStackedColumnChart.vue